/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-09 16:12:50
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-16 15:22:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/Preview/util.tsx
 */
import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { onCollapseOpen } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/slice';

import {
  Poster,
  PosterCarousel,
  ProductCarousel,
  ProductScrollList,
  LongCanvas,
  Text,
  ProductGrid,
  ProductList,
} from 'unifyxp-ecomm-components';

import {
  scroll,
  mapLeftAnchorName,
  mapRightAnchorName,
} from '@/src/tools/helper';

export const ModuleList = ({ rawData, getContent, getCollapseStatus }) => {
  const { moduleContentOrder } = rawData;
  return (
    <>
      {moduleContentOrder.map((mod) => {
        const key = `${mod.draggableId}`;
        return (
          <div key={key}>
            <Module
              order={mod}
              getContent={getContent}
              getCollapseStatus={getCollapseStatus}
            />
          </div>
        );
      })}
    </>
  );
};

export const Module = ({ order, getContent, getCollapseStatus }) => {
  const _data: any = useSelector(getContent(order.draggableId));
  const open = useSelector(getCollapseStatus(order.draggableId));
  const { staticData: staticConfig, dynamicData: dynamicConfig = [] } = _data;
  const moduleType = order.moduleType;
  switch (moduleType) {
    case ModuleType.Carousel: {
      const { autoPlay, intervalTime, posterType, visible } = staticConfig;
      const list = Array.isArray(dynamicConfig)
        ? dynamicConfig.map((i) => ({
            imageUrl: _.get(i, 'linkImage.url', ''),
          }))
        : [];
      const amount = mapCarouselType(posterType);
      const data = buildRenderingData(list, amount);
      const carouselData = data.map((d) => ({ imageProps: d }));
      const Wrapped = withDraggableId(
        PosterCarousel,
        order.draggableId,
        onCollapseOpen,
      );
      return renderByVisiblity(
        visible || open,
        <Wrapped
          carousels={carouselData}
          autoPlay={autoPlay}
          infiniteLoop={autoPlay}
          interval={Number(intervalTime) ? intervalTime * 1000 : 0}
        />,
      );
    }
    case ModuleType.ProductCarousel: {
      const { autoPlay, intervalTime, productToShow, scrollType, visible } =
        staticConfig;
      const products = Array.isArray(dynamicConfig) ? dynamicConfig : [];
      const amount = mapCarouselType(productToShow);
      const data = buildRenderingData(products, amount);
      if (scrollType === EnumScrollType.Paged) {
        const Wrapped = withDraggableId(
          ProductCarousel,
          order.draggableId,
          onCollapseOpen,
        );
        return renderByVisiblity(
          visible || open,
          <Wrapped
            productSet={data}
            autoPlay={autoPlay}
            infiniteLoop={autoPlay}
            interval={Number(intervalTime) ? intervalTime * 1000 : 0}
            oneProductType={amount === 1}
          />,
        );
      } else {
        const Wrapped = withDraggableId(
          ProductScrollList,
          order.draggableId,
          onCollapseOpen,
        );
        return renderByVisiblity(
          visible || open,
          <Wrapped amountOfShow={amount} products={products} />,
        );
      }
    }
    case ModuleType.Poster: {
      const { visible } = staticConfig;
      const data = Array.isArray(dynamicConfig)
        ? dynamicConfig.map((i) => ({
            imageUrl: _.get(i, 'linkImage.url', ''),
          }))
        : [];
      const Wrapped = withDraggableId(
        Poster,
        order.draggableId,
        onCollapseOpen,
      );
      return renderByVisiblity(visible || open, <Wrapped imageProps={data} />);
    }
    case ModuleType.LongCanvas: {
      const { visible } = staticConfig;
      const data = Array.isArray(dynamicConfig)
        ? dynamicConfig.map((i) => ({
            imageUrl: _.get(i, 'linkImage.url', ''),
          }))
        : [];
      const Wrapped = withDraggableId(
        LongCanvas,
        order.draggableId,
        onCollapseOpen,
      );
      return renderByVisiblity(visible || open, <Wrapped imageProps={data} />);
    }
    case ModuleType.Text: {
      const { backgroundColor, textColor, header, content, visible, seoTag } =
        staticConfig;
      const Wrapped = withDraggableId(Text, order.draggableId, onCollapseOpen);
      return renderByVisiblity(
        visible || open,
        <Wrapped
          seoTag={seoTag}
          title={header}
          content={content}
          fontColor={textColor}
          backgroundColor={backgroundColor}
        />,
      );
    }
    case ModuleType.ProductGrid: {
      const { backgroundColor, visible, productToShow } = staticConfig;
      const products = Array.isArray(dynamicConfig) ? dynamicConfig : [];
      const Wrapped = withDraggableId(
        ProductGrid,
        order.draggableId,
        onCollapseOpen,
      );
      const getType = () => {
        if (productToShow === EnumCarouselOptions.Two) return 1;
        if (productToShow === EnumCarouselOptions.Three) return 2;
      };
      return renderByVisiblity(
        visible || open,
        <Wrapped
          data={products}
          style={{ backgroundColor }}
          type={getType()}
        />,
      );
    }
    case ModuleType.ProductList: {
      const { visible } = staticConfig;
      const products = Array.isArray(dynamicConfig) ? dynamicConfig : [];
      const Wrapped = withDraggableId(
        ProductList,
        order.draggableId,
        onCollapseOpen,
      );
      return renderByVisiblity(visible || open, <Wrapped data={products} />);
    }
    default:
      return <div />;
  }
};
//  carousels={carouselData}
//           autoPlay={autoPlay}
//           infiniteLoop={autoPlay}
//           interval={Numbe
// const _MemoComp = (props) => {
//   const { id, carousels, autoPlay, infiniteLoop, interval } = props;
//   const Comp = withDraggableId(PosterCarousel, id, onCollapseOpen);
//   return (
//     <Comp
//       carousels={carousels}
//       autoPlay={autoPlay}
//       infiniteLoop={infiniteLoop}
//       interval={interval}
//     />
//   );
// };

export const buildRenderingData = (list, amount) => {
  const result = [];
  let item = [];
  for (let i = 0; i <= list.length; i++) {
    if (i % amount !== 0 || i === 0) {
      item.push(list[i]);
    } else if (i % amount === 0) {
      result.push(item);
      item = [list[i]];
    }
  }
  return result;
};

export const mapCarouselType = (type: EnumCarouselOptions) => {
  switch (type) {
    case EnumCarouselOptions.One:
      return 1;
    case EnumCarouselOptions.Two:
      return 2;
    case EnumCarouselOptions.Three:
      return 3;
    case EnumCarouselOptions.Four:
      return 4;
    case EnumCarouselOptions.Five:
      return 5;
    default:
      return 0;
  }
};

export const renderByVisiblity = (visible: boolean, Component: any) => {
  if (visible) return Component;
  else return <React.Fragment></React.Fragment>;
};

export interface Module {
  moduleType: ModuleType;
  draggableId: string;
}

enum ModuleType {
  Carousel = 'Carousel',
  ProductCarousel = 'ProductCarousel',
  Poster = 'Poster',
  LongCanvas = 'LongCanvas',
  Text = 'Text',
  ProductGrid = 'ProductGrid',
  ProductList = 'ProductList',
}

enum EnumCarouselOptions {
  Two = 'Two',
  One = 'One',
  Three = 'Three',
  Four = 'Four',
  Five = 'Five',
}

enum EnumScrollType {
  Smooth = 'Smooth',
  Paged = 'Paged',
}
export const withDraggableId = (Component, id: string, onCollapseOpen) => {
  return (props) => {
    const dispatch = useDispatch();
    const handleClick = () => {
      dispatch(onCollapseOpen({ idArr: [id] }));
      scroll(mapRightAnchorName(id));
    };
    return (
      <div key={id} id={mapLeftAnchorName(id)} onClick={handleClick}>
        <Component {...props} />
      </div>
    );
  };
};
